export default __webpack_public_path__ + "static/media/wavebackground.424df2ed.jpg";